var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.318 0.5H2.58621C1.14943 0.5 0 1.64943 0 3.08621V16.6877C0 18.1245 1.14943 19.2739 2.58621 19.2739H22.4138C23.8506 19.2739 25 18.1245 25 16.6877V3.08621C24.9042 1.64943 23.7548 0.5 22.318 0.5ZM6.13027 14.8678L4.31034 13.0479L7.66284 9.6954L4.31034 6.34291L6.13027 4.52299L11.3027 9.6954L6.13027 14.8678ZM20.5939 15.251H14.6552V12.6648H20.5939V15.251Z",
    fill: "#2A3953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon);
export default __webpack_public_path__ + "static/media/IntegrationIcon.7d2ccce42d1759c92b2bb0eb59057ddd.svg";
export { ForwardRef as ReactComponent };